import ReactTooltip from 'react-tooltip';
import styled from 'styled-components';

export const Container = styled.span`
  & .custom-tooltip{
    box-shadow: 0 -1px 12px 0 rgb(0 0 0 / 10%);
    pointer-events: auto !important;
    &:hover {
      visibility: visible !important;
      opacity: 1 !important;
    }
  }
  svg {
    fill: #9D9EA2;
    font-size: 16px;
  }

  & .place-bottom::after {
    border-left: 16px solid transparent !important;
    border-right: 16px solid transparent !important;
    top: -8px !important;
    // left: 50% !important;
    margin-left: -16px !important;
    border-bottom-style: solid ;
    border-bottom-width: 8px !important;
  }

  & .place-top::after {
    border-left: 16px solid transparent !important;
    border-right: 16px solid transparent !important;
    bottom: -8px !important;
    // left: 50% !important;
    margin-left: -16px !important;
    border-top-style: solid ;
    border-top-width: 8px !important;
  }
`

export const Popover = styled(ReactTooltip)`
  & {
    padding: 10px !important;
    font-weight: 400;
    font-size: 12px;
    line-height: 19px;
    color: #202124;
  }

  & a {
    color: #3E81F6;
  }

`
